var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBgPattern1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 341,
    height: 317,
    viewBox: "0 0 341 317",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#44FFA1",
    transform: "rotate(-152 159.204 128.626)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 54,
    cy: 107.125,
    rx: 53.5,
    ry: 106.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 94.706,
    cy: 107,
    rx: 53.5,
    ry: 106.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 134.529,
    cy: 107.344,
    opacity: 0.75,
    rx: 52.5,
    ry: 106.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 175.705,
    cy: 108.102,
    opacity: 0.5,
    rx: 53.5,
    ry: 106.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 217.294,
    cy: 107.508,
    opacity: 0.25,
    rx: 52.5,
    ry: 106.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgPattern1);
export default __webpack_public_path__ + "static/media/bg-pattern-1.bfa7d51bac5e5ebf6188fc8b02b830bd.svg";
export { ForwardRef as ReactComponent };